import { FC } from 'react';
import {
  SelfServeDataAccessStatus,
  SelfServeDataAccessStatusMap,
  DataAccessProvider,
  MMP_SOURCE_MAP,
} from '@constants/constants';
import { Stack, Typography } from '@mui/material';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';

interface DataProcessingErrorCardProps {
  dataSource: DataAccessProvider;
  status: SelfServeDataAccessStatus;
}

const DataProcessingErrorCard: FC<DataProcessingErrorCardProps> = ({ dataSource, status }) => {
  return (
    <Stack
      sx={{
        gap: '1rem',
        padding: '1.25rem',
        border: '2px solid #2F736E1F',
        borderRadius: '1rem',
      }}
    >
      {/* Header */}
      <Stack direction={'row'} alignItems={'center'} gap={'1rem'}>
        {/* Icon */}
        <CancelPresentationIcon sx={{ fontSize: 24, color: '#FF6347' }} />

        <Typography fontSize={14} lineHeight={1.25} color={'#FF6347'} fontWeight={700}>
          Error: {SelfServeDataAccessStatusMap[status]} for {MMP_SOURCE_MAP[dataSource]}
        </Typography>
      </Stack>

      {/* Body */}
      <Typography fontSize={14} lineHeight={1.25} color={'#162936'} fontWeight={500}>
        Please reach out to us at info@pvxpartners.com for assistance.
      </Typography>
    </Stack>
  );
};

export default DataProcessingErrorCard;
